import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';
import { makeProvider } from '../../helpers/makeContexts';

const dashCategoriesInit = {
  dashboardCategories: {},
};

function dashCategoriesReducer(draft, { type, payload }) {
  switch (type) {
    case 'setDashCategories': {
      let newState = {};
      // if not normalized
      if (payload && payload.DashboardCategories) {
        if (payload.DashboardCategories.length) {
          for (let i = 0; i < payload.DashboardCategories.length; i++) {
            let dashCat = payload.DashboardCategories[i];
            newState[dashCat.id] = dashCat;
          }
        }
        draft.dashboardCategories = newState;
      } else {
        // passing in the selectedDash with normalized categories
        draft.dashboardCategories = payload;
      }
      break;
    }
    default: {
      return null;
    }
  }
}

const [DashCategoriesContext, DashCategoriesDispatchContext] = [
  createContext(null),
  createContext(null),
];

export const DashboardCategoriesProvider = makeProvider(
  DashCategoriesContext,
  DashCategoriesDispatchContext,
  dashCategoriesReducer,
  dashCategoriesInit
);

export function useDashboardCategories() {
  return useContext(DashCategoriesContext);
}

export function useDashboardCategoriesDispatch() {
  return useContext(DashCategoriesDispatchContext);
}
